/* eslint-disable import/no-commonjs */
/* eslint-disable import/unambiguous */

module.exports = {
  isClient: true,
  isServer: false,
  websiteGlobal: window,
};
